export const img_url = "https://image.tmdb.org/t/p/w300";

// export const img_500 = "https://image.tmdb.org/t/p/w500";


export const unavailable =
  "https://www.movienewz.com/img/films/poster-holder.jpg";

  export const api_key = "6518ae7cd3d526b4453531051cc4d408"